const toggleDetailsOpen = (open: boolean = false): void =>
  document
    .querySelectorAll("details")
    .forEach((details) => (details.open = open));

window.addEventListener("beforeprint", () => toggleDetailsOpen(true));
window.addEventListener("afterprint", () => toggleDetailsOpen(false));

const printLinks = document.querySelectorAll(".js-print");

printLinks.forEach((link) => {
  link.addEventListener("click", () => {
    window.print();
  });
});
